import React from "react";

import DefaultModal, { IModalProps } from "../Modal";

import { Search } from "react-feather";

import dialCodes from "../../assets/misc/dialCodes.json";
import { DialCode } from "../../utils/dialCode";

import styles from "./DialCodePicker.module.scss";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  select: (data: DialCode) => void;
  modalStyle?: IModalProps["style"];
}

const DialCodePickerModal: React.FC<IProps> = ({
  visible,
  setVisible,
  select,
  modalStyle,
}) => {
  const [codes, setCodes] = React.useState(dialCodes);

  const inputRef = React.useRef<HTMLInputElement>(null);
  const resetTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  // The reset below is deferred so the list doesn't visibly repopulate under
  // the closing modal; drop it if we're gone by then.
  React.useEffect(
    () => () => {
      if (resetTimer.current) clearTimeout(resetTimer.current);
    },
    [],
  );

  const handleSearch = (e) => {
    const term = e.target.value;
    let matchedItemsArray: any = [];
    if (term === "") {
      setCodes(dialCodes);
    } else {
      dialCodes.forEach((item) => {
        item.data.forEach((c) => {
          if (c.name.toLowerCase().includes(term.toLowerCase())) {
            let index = matchedItemsArray.findIndex(
              (x) => x.title === item.title,
            );
            index === -1
              ? matchedItemsArray.push({ title: item.title, data: [c] })
              : matchedItemsArray[index].data.push(c);
          }
        });
      });

      setCodes(matchedItemsArray);
    }
  };

  return (
    <DefaultModal
      active={visible}
      setActive={setVisible}
      style={{
        minHeight: "auto",
        paddingLeft: 20,
        paddingRight: 20,
        ...modalStyle,
        borderRadius: "18px",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span className={styles.Title}>Choose Country</span>
        <label className={styles.SearchLabel + " " + styles.Active}>
          <input
            id="country"
            name="country"
            ref={inputRef}
            onChange={handleSearch}
            className={styles.SearchInput}
            type="text"
          />
          <Search className={styles.ImgSearch} />
        </label>

        <div style={{ maxHeight: "50vh", overflowY: "auto", width: "100%" }}>
          {codes.map((item) => (
            <div key={"s" + item.title}>
              <span className={styles.ABCLetter}>{item.title}</span>
              {item.data.map((code) => (
                <div
                  key={code.code + code.dial_code}
                  className={styles.item}
                  onClick={() => {
                    select({
                      flag: code.flag,
                      dial_code: code.dial_code,
                      // ISO-2 code: what libphonenumber needs to read a number
                      // typed in national format.
                      code: code.code,
                    });
                    resetTimer.current = setTimeout(() => {
                      if (inputRef.current) inputRef.current.value = "";
                      setCodes(dialCodes);
                    }, 400);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <span style={{ marginRight: 6 }}>{code.flag}</span>
                      {code.name}
                    </div>

                    <div className={styles.muted}>{code.dial_code}</div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </DefaultModal>
  );
};

export default DialCodePickerModal;
